<template>
  <div class="fragment">
    <div class="order-create__section-label section-label"
         v-bind:class="{'admin-edit-item': isAdmin || checkImpersonate()}">
      <div class="admin-edit" @click="editTranslate([
        'consolidations_documents',
      ])"></div>
      {{$t('consolidations_documents.localization_value.value')}}
    </div>

    <div class="order-create__row custom-row">
      <div class="custom-col d-flex align-items-center mb-3"
           v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
        <div class="admin-edit" @click="editTranslate([
                'express_ToxicSubstance',
                'express_NeededForSuch',
              ])"></div>
        <DefaultCheckbox
            v-model="consolidation.data.gccCpcCertificate"
            :label="$t('express_GCCCPC.localization_value.value')"
            @click="consolidation.data.gccCpcCertificate = !consolidation.data.gccCpcCertificate"
        />
      </div>

      <div class="order-create__col custom-col position-relative"
           :class="{'mb-4' : consolidation.data.gccCpcCertificateFiles.validation.files, 'mb-2' : !consolidation.data.gccCpcCertificateFiles.validation.files}"
           v-if="consolidation.data.gccCpcCertificateFiles.data.maxCountFiles - Object.keys(consolidation.data.gccCpcCertificateFiles.data.downloadFiles).length > 0 &&
               consolidation.data.gccCpcCertificate"
      >
        <DropZone
            class="drop-zone-bg"
            :multiple="true"
            :parentFiles="consolidation.data.gccCpcCertificateFiles.data.files"
            :maxCount="consolidation.data.gccCpcCertificateFiles.data.maxCountFiles - consolidation.data.gccCpcCertificateFiles.data.downloadFiles.length"
            :maxSize="consolidation.data.gccCpcCertificateFiles.data.maxSizeFiles"
            :accept="'application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document'"
            @changeImg="changeGccCpcCertificateFile"
        />
        <span class="error-field ml-3" v-if="consolidation.data.gccCpcCertificateFiles.validation.files">
              {{$t('common_fileIsRequired.localization_value.value')}}
            </span>
      </div>

      <div class="custom-row product-img-row w-100" v-if="Object.keys(consolidation.data.gccCpcCertificateFiles.data.downloadFiles).length > 0">
        <div class="custom-col custom-col--16 custom-col--md-50 custom-col--sm-100 mt-3"
             v-for="(file, indexFile) in consolidation.data.gccCpcCertificateFiles.data.downloadFiles" :key="indexFile">
          <DownloadFileBlock :file="file" @removeFile="(id) => {removeGccCpcCertificateFile(id, indexFile)}"/>
        </div>
      </div>

      <div class="order-create__col custom-col mb-3"
           v-bind:class="{'admin-edit-item': isAdmin || checkImpersonate()}">
        <div class="admin-edit" @click="editTranslate([
          'consolidations_toxicLabel',
          'consolidations_toxicLabelHelp',
          'express_DropBallTest',
        ])"></div>
        <DefaultCheckbox
            :label="$t('consolidations_toxicLabel.localization_value.value')"
            v-model="consolidation.data.toxicSubstance"
        >
          <template slot="content">
            <v-popover
                class="site-tooltip mt--1"
                :disabled="!tooltipAddProductActive"
                offset="5"
                placement="top"
                trigger="hover"

            >
              <span>
                <TooltipBtn/>
              </span>
              <template slot="popover">
                <p>
                  <b>{{$t('consolidations_toxicLabel.localization_value.value')}}</b>
                </p>
                <p>
                  {{$t('consolidations_toxicLabelHelp.localization_value.value')}}
                </p>
              </template>
            </v-popover>
          </template>
        </DefaultCheckbox>
      </div>
<!--      <div class="order-create__col custom-col mb-3">-->
<!--        <DefaultCheckbox-->
<!--            :label="$t('express_DropBallTest.localization_value.value')"-->
<!--            v-model="consolidation.data.dropCertification"-->
<!--        >-->
<!--          <template slot="content">-->
<!--            <v-popover-->
<!--                class="site-tooltip mt&#45;&#45;1"-->
<!--                :disabled="!tooltipAddProductActive"-->
<!--                offset="5"-->
<!--                placement="top"-->
<!--                trigger="hover"-->

<!--            >-->
<!--                          <span>-->
<!--                            <TooltipBtn/>-->
<!--                          </span>-->
<!--              <template slot="popover">-->
<!--                <p>-->
<!--                  <b>{{$t('express_DropBallTest.localization_value.value')}}</b>-->
<!--                </p>-->
<!--                <p>-->
<!--                  {{$t('consolidations_toxicLabelHelp.localization_value.value')}}-->
<!--                </p>-->
<!--              </template>-->
<!--            </v-popover>-->
<!--          </template>-->
<!--        </DefaultCheckbox>-->
<!--      </div>-->

    </div>
  </div>
</template>

<script>
import DefaultCheckbox from "../../../../../../UI/checkboxes/DefaultCheckbox/DefaultCheckbox";
import TooltipBtn from "../../../../../../UI/tooltips/TooltipBtn/TooltipBtn";
import DownloadFileBlock from "@/components/coreComponents/DownloadFileBlock/DownloadFileBlock";
import DropZone from "@/components/coreComponents/DropZone/DropZone";

export default {
  name: "DocumentsBlock",

  components: {
    DropZone,
    DownloadFileBlock,
    TooltipBtn,
    DefaultCheckbox
  },

  props: {
    consolidation: Object,
  },

  data() {
    return {
      tooltipAddProductActive: true,
    }
  },

  methods: {
    changeGccCpcCertificateFile(files, maxSizeError) {
      this.consolidation.data.gccCpcCertificateFiles.setFiles(files)

      this.consolidation.data.gccCpcCertificateFiles.setFilesMaxSizeError(maxSizeError)
    },

    removeGccCpcCertificateFile(id, index) {
      let text = {
        title: 'common_deleteConfirm',
        txt: '',
        yes: 'common_confirm',
        no: 'common_confirmNo'
      }

      let confirm = () => {
        this.$store.dispatch('removeUserDocument', id).then((response) => {
          switch (this.getResponseStatus(response)) {
              /**
               * Success
               */
            case this.$store.getters.GET_ERRORS.SUCCESS_CODE: {
              this.consolidation.data.gccCpcCertificateFiles.removeDownloadFile(index)
              this.openNotify('success', 'common_notificationRecordDeleted')
              break
            }
              /**
               * Validation Error
               */
            case this.$store.getters.GET_ERRORS.VALIDATION_ERROR_CODE: {
              let errors = response.response.data.errors;
              this.notifyErrorHelper(errors)
              break
            }
              /**
               * Undefined Error
               */
            default: {
              this.openNotify('error', 'common_notificationUndefinedError')
            }
          }
        }).catch(error => this.createErrorLog(error))

        this.$store.commit('setConfirmDeletePopup', false)
        return true
      }

      this.deleteFunc(text, confirm)
    },
  }
}
</script>

<style scoped>

</style>